import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "../auth-guard.service";
import { AccountGuard } from "../account-guard.service";
import { ReportsComponent } from "./reports.component";
import { ReportDetailComponent } from "./reportdetail.component";
import { ReportsService } from "./reports.service";

@NgModule({
  imports:[      
      SharedModule,
      RouterModule.forChild([
        { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard, AccountGuard] },
        { path: 'reportdetail/:name', component: ReportDetailComponent, canActivate: [AuthGuard, AccountGuard] }
      ])
    ],
    exports: [
        
    ],
    declarations: [
      ReportsComponent,
      ReportDetailComponent
    ],
    providers: [        
      ReportsService
    ]
})
export class ReportsModule{

}



// WEBPACK FOOTER //
// ./src/app/reports/reports.module.ts